import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AuthenticationService} from '../authentication/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class NotationService {
  constructor(private http: HttpClient,
              private authenticationService: AuthenticationService
  ) {

  }

  getNotes(noteId) {
    return this.http.get(`notation/safe/${noteId}`);
  }

  getAutomaticNotes(noteId, notedAt) {
    return this.http.get(`notation/safe/thermal-correction?project=${noteId}&date=${notedAt}`);
  }

  postNote(date, justification, notedLocations, projectId) {
    let request = {
      user: this.authenticationService.getStoredUser().id,
      project: projectId,
      noted_at: date,
      note_justification: justification,
      note_project_device_locations: notedLocations
    };

    return this.http.post('notation/safe', request);
  }

  patchNote(noteId, date, justification, notedLocations) {
    let request = {
      user: this.authenticationService.getStoredUser().id,
      noted_at: date,
      note_justification: justification,
      note_project_device_locations: notedLocations
    };

    return this.http.patch(`notation/safe/${noteId}`, request);
  }

  deleteNote(noteId) {
    return this.http.delete(`notation/safe/${noteId}`);
  }


  // order devices (parent, ...children, parent, ...children, etc)
  orderDevices(devices) {

    let orderedDevices = devices.reduce(
      (devices, device, index, originalArray) => {
        if (device.parent) {
          return devices;
        }
        let children = device.children.map(
          (child) => originalArray.find(
            (location) => location.id === child.id || location.id === child.id
          )
        );
        return devices.concat(device).concat(children);
      }, []
    );

    return orderedDevices instanceof Array ? orderedDevices : [];
  }

  static getIconUrl(type: number = undefined, noteLitteral: string = undefined): string {

    let url = '../../../../assets/images/page-project-markers/';

    switch (type) {
      case 4:
        return url + 'oasys-Temp.png';
      case (1 || 5):
        return url + 'liris' + (noteLitteral ? ('-' + noteLitteral) : '') + '.png';
      case (2 || 3):
        return url + 'oasys' + (noteLitteral ? ('-' + noteLitteral) : '') + '.png';
      default:
        return url + 'sensor' + (noteLitteral ? ('-' + noteLitteral) : '') + '.png';
    }

  }

  addIconUrlsToDevices(devices, notes = undefined) {

    devices.forEach(
      (device) => device.icon_url = NotationService.getIconUrl(device.device_type ? device.device_type.id : undefined, device.note_litteral)
    );

    if (notes && notes.note_project_device_locations) {
      notes.note_project_device_locations.forEach(
        (note) => {
          if (!note.note_litteral) {
            return;
          }
          let i = devices.findIndex(
            (location) => location.location_id === note.location_id || location.id === note.location_id
          );
          if (i > -1) {
            // If 'manu' === true and note.note_litteral is undefined, then the note was manually ignored
            devices[i].note_litteral = note.note_litteral;
            devices[i].icon_url = NotationService.getIconUrl(devices[i].device_type ? devices[i].device_type.id : undefined, note.note_litteral);
          }
        }
      );
    }

    return devices;
  }

}
